import { Button, ChipMenu, GenericSuspense, List, useListFilterState, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useUserStudentFamilyListSort } from "../hooks/useUserStudentFamilyListSort";
import { UserStudentFamiliesQuery } from "../queries/UserStudentFamiliesQuery";
import { TUserStudentFamily } from "@bsm/graphql";
import { UserStudentFamilyListItem } from "../components/UserStudentFamilyListItem";
import { Link, Outlet } from "react-router-dom";
import { useCurrencyMenuItems } from "../hooks/useCurrencyMenuItems";
import { useEffect, useMemo, useState } from "react";

export const UserStudentFamilyListContainer = () => {

    const { filter, setFilter } = useListFilterState(FAMILY_LIST_ID,false);
    const [TITLE, ADD] = useTranslations(i18n);
    const urlParams = useUrlParamsValueToString()
    const sortItems = useUserStudentFamilyListSort();
    const currencyMenuItems = useCurrencyMenuItems();


    const activeMenus = useMemo(() => {


        return {
            currency: filter?.data?.currencies?.value
                ? currencyMenuItems?.find((item) => item.value === filter?.data?.currencies?.value)
                : currencyMenuItems[0],
        };
    }, [filter?.data?.currencies?.value]);



    return (
        <div>
            <div className="flex justify-between mb-4">
                <h3 className="font-semibold">{TITLE}</h3>
                <Link to={`-1?${urlParams}`}>
                    <Button
                        className="btn-default"
                        startIcon="fa-solid fa-plus"
                        label={ADD}
                    />
                </Link>
            </div>

            <div className="flex justify-end mb-6">
                <ChipMenu
                    items={currencyMenuItems}
                    value={activeMenus?.currency?.value}

                    className="w-35"

                    onClick={(menu) => {
                        setFilter((v: any) => ({
                           ...v, 
                            data: {
                                ...v.data,
                                currencies: {
                                    value: menu.id !== 0 ? menu.value : undefined,
                                },
                            },
                        }));

                    }}
                />
            </div>

            <List
                id={FAMILY_LIST_ID}
                sort={{ items: sortItems }}
                selection={false}
                isUrlParamsState={false}
                GQLRequest={UserStudentFamiliesQuery}
                defaultFilter={{
                    pageSize: 50,
                    page: 0,
                    sort: [{ value: "updatedAt", sort: "DESC" }],
                }}
                onRenderRow={(row: TUserStudentFamily) => (
                    <UserStudentFamilyListItem {...row} />
                )}
            />

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </div>
    );
};

export const FAMILY_LIST_ID = "family-list";

const i18n = [
    "std_familly",
    'std_add'
];
